<div *ngIf="isLoading" class="loading">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>
</div>
  
<con-page-layout *ngIf="dataSource.data.length > 0">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'health' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'health_stats_last_refresh' | translate }}{{healthStatsLastRefresh}}</div>
  <br />
  
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <div class="matTable-container">
      <mat-table matSort *ngIf="media.isActive('lg') || media.isActive('xl')" #table 
      [dataSource]="dataSource" class="mat-elevation-z8">
  
        <!-- Class Name Column -->
        <ng-container cdkColumnDef="class_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'class_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.class_name}} </mat-cell>
        </ng-container>
  
        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'account_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.account_name}} </mat-cell>
        </ng-container>
    
        <!-- First Name Column -->
        <ng-container cdkColumnDef="first_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'first_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.first_name}} </mat-cell>
        </ng-container>
    
        <!-- Last Name Column -->
        <ng-container cdkColumnDef="last_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'last_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.last_name}} </mat-cell>
        </ng-container>
    
        <!-- Email-Id Column -->
        <ng-container cdkColumnDef="email_id">
        <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'student_email' | translate }}</mat-header-cell>
        <mat-cell fxFlex="15%" *cdkCellDef="let healthstat"> {{healthstat.email_id}} </mat-cell>
        </ng-container>
    
        <!-- Folder Name Column -->
        <ng-container cdkColumnDef="folder_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'folder_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.folder_name}} </mat-cell>
        </ng-container>
    
        <!-- Group Name Column -->
        <ng-container cdkColumnDef="group_name">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'group_name' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.group_name}} </mat-cell>
        </ng-container>
    
        <!-- Service Column -->
        <ng-container cdkColumnDef="service">
        <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'service' | translate }}</mat-header-cell>
        <mat-cell fxFlex="15%" *cdkCellDef="let healthstat"> {{healthstat.services}} </mat-cell>
        </ng-container>
    
        <!-- HealthStat Column -->
        <ng-container cdkColumnDef="health">
        <mat-header-cell fxFlex="10%" *cdkHeaderCellDef mat-sort-header>{{ 'health' | translate }}</mat-header-cell>
        <mat-cell fxFlex="10%" *cdkCellDef="let healthstat"> {{healthstat.health}} </mat-cell>
        </ng-container>
    
        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>

    <br />
      
  <!-- Mobile view -->
  <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl'))">
  <ng-template ngFor let-available [ngForOf]="dataSource.data">
      <mat-list-item>
      <div fxLayout="column" fxLayoutGap="8px">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div fxFlex="200px"><b>{{ 'class_name' | translate }}:</b></div>
          <div class="breakword" fxFlex fxLayout="row">{{available.class_name}}</div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div fxFlex="200px"><b>{{ 'account_name' | translate }}:</b></div>
          <div class="breakword" fxFlex fxLayout="row">{{available.account_name}}</div>
          </div>
      </div>
      </mat-list-item>
      <mat-divider></mat-divider>
  </ng-template>
  </mat-list>

  </con-page-layout-content>
</con-page-layout>